<template>
  <v-app>
    <v-app-bar
      app
      clipped-left
      elevate-on-scroll
      color="primary"
      dark>
      <v-toolbar-title><b>Priam-hallintaliittymä</b> <small>beta</small></v-toolbar-title>
    </v-app-bar>

    <v-content>
      <v-container>
        <transition name="scroll-y-transition" mode="out-in">
          <router-view></router-view>
        </transition>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
//import HelloWorld from './components/HelloWorld';

export default {
  name: 'App',

  components: {
    
  },

  data: () => ({
    //
  }),
};
</script>
